<template>
  <div :class="inputClasses">
    <input
      :type="showPassword ? (passwordVisible ? 'text': 'password') : type"
      :placeholder="placeholder"
      v-bind="$attrs"
      :class="`${NAME_PRE}-input__inner`"
      :disabled="disabled"
      @input="handleInput"
      :style="inputStyles"
      ref="input"
    >
    <!-- 后缀 -->
    <span
      class="suffix"
      v-if="getSuffixVisible()"
    >
      <hc-icon
        icon="round-close"
        class="close"
        v-if="showClear"
        @click.prevent="clear"
      ></hc-icon>
      <hc-icon
        icon="circle-view"
        v-if="showPwdVisible"
        @click.prevent="handlePasswordVisible"
      ></hc-icon>
    </span>

  </div>
</template>
<script>
import { NAME_PRE } from '@/packages/constant/index';
export default {
  name: `${NAME_PRE}-input`,

  props: {
    value: [String, Number],

    name: {
      type: String,
      default: null,
    },

    type: {
      type: String,
      default: 'text',
    },

    placeholder: {
      type: String,
      default: '请输入内容',
    },

    size: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: false,
    },

    border: {
      type: String,
      default: '',
    },

    showPassword: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    inputClasses() {
      let classes = [`${NAME_PRE}-input`];
      if (this.size) {
        classes.push(`${NAME_PRE}-input--${this.size}`);
      }

      if (this.disabled) {
        classes.push(`${NAME_PRE}-input--disabled`);
      }

      if (this.border) {
        classes.push(`${NAME_PRE}-input--bottom`);
      }
      return classes;
    },

    inputStyles() {
      let styles = {};
      if (this.clearable) {
        styles = {
          ...styles,
          paddingRight: '25px',
        };
      }
      return styles;
    },

    nativeInputValue() {
      return this.value === null || this.value === undefined
        ? ''
        : String(this.value);
    },

    showClear() {
      return this.clearable && !this.disabled && this.nativeInputValue;
    },

    showPwdVisible() {
      return this.showPassword && !this.disabled && this.nativeInputValue;
    },
  },

  data() {
    return {
      NAME_PRE,
      passwordVisible: false,
    };
  },

  watch: {
    nativeInputValue() {
      this.setNativeInputValue();
    },
  },

  mounted() {
    this.setNativeInputValue();
  },

  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value);
    },

    clear() {
      this.$emit('input', '');
    },

    getSuffixVisible() {
      return this.showClear || this.showPwdVisible;
    },

    setNativeInputValue() {
      const input = this.getInput();
      if (!input) return;
      if (input.value === this.nativeInputValue) return;
      input.value = this.nativeInputValue;
    },

    getInput() {
      return this.$refs.input;
    },

    handlePasswordVisible() {
      this.passwordVisible = !this.passwordVisible;
      // this.focus();
    },
  },
};
</script>